import React from 'react';
import { Modal, Button, Row, Col } from 'antd';
import { CloseIcon } from '../../../../assets/icons';
import { requestNameChange } from '../../../../services/AccountApi/profileApi';
import { toastNotify } from '../../../../utils/toastNotify';


const ReqNameChange = (props) => {

  const handleReqNameChange = async() => {
    try {
      const resp = await requestNameChange();
      if (!resp.isError) {
        toastNotify('success', resp?.message);
        props.setClose();
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    }
  }

  return (
    <>
      <Modal open={props.setOpen} onCancel={()=>props.setClose()} closeIcon={<CloseIcon />} footer={false} width={524} centered>
        <h4 className='mb-32 text-center success__title'>Request a name change</h4>
        <p>To change the legal name on your account, we are required to re-verify your identity. </p>
        <p className='mb-48'>For security purposes, we’ll send you an email with a link to proceed with this process.</p>
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12}>
            <Button className='w-100' onClick={()=>{props.setClose();props.setBackModal()}}>Cancel</Button>
          </Col>
          <Col span={24} sm={12}>
            <Button
              className='w-100'
              type='primary'
              onClick={() => handleReqNameChange()}
            >
              Submit request
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ReqNameChange;
